<div class="info-container">
  @if (displayWarningMaxSpanLength()) {
    <div class="warning-pill-wrapper">
      <gc-pill [color]="'caution'">{{
        'selectSpanMode.warningMaxSpanLength' | translate
      }}</gc-pill>
    </div>
  }
  <div class="text-wrapper">
    <div class="title-wrapper">
      <gc-text [variant]="'minorHeading'">
        {{
          isEditMode()
            ? ('selectSpanMode.editTitle' | translate)
            : ('selectSpanMode.title' | translate)
        }}
      </gc-text>
      <gc-button
        [variant]="'utility'"
        [size]="'small'"
        [icon]="'circleQuestion'"
        (clicked)="openHelpModal()"
        >{{ 'selectSpanMode.help' | translate }}</gc-button
      >
    </div>
    @if (!displayWarningMaxSpanLength()) {
      <gc-text [variant]="'paragraph'">
        {{
          isEditMode()
            ? ('selectSpanMode.editSubtitle' | translate)
            : ('selectSpanMode.subtitle' | translate)
        }}
      </gc-text>
    }
  </div>

  <div class="span-wrapper">
    <div class="span-color"></div>
    <div class="span-text-wrapper">
      <gc-text [variant]="'minorHeading'" [textColor]="'invert'">
        {{ selectedSpanLength() + ' ' + ('selectSpanMode.meters' | translate) }}
      </gc-text>
      <gc-text [variant]="'paragraphBold'" [textColor]="'invert'">
        {{ 'selectSpanMode.selectedDistance' | translate }}
      </gc-text>
    </div>
  </div>

  <div class="button-wrapper">
    <gc-button [variant]="'secondary'" (clicked)="cancelSelectSpanMode()">
      {{ 'selectSpanMode.cancel' | translate }}
    </gc-button>
    @if (isEditMode()) {
      <gc-button
        (clicked)="updateReport()"
        [isLoading]="updateV3ReportMutation.getStateOnce().isLoading"
      >
        {{ 'selectSpanMode.updateReport' | translate }}
      </gc-button>
    } @else {
      <gc-button
        (clicked)="createReport()"
        [isLoading]="createV3ReportMutation.getStateOnce().isLoading"
        [disabled]="selectedSpanIds().length === 0"
      >
        {{ 'selectSpanMode.createReport' | translate }}
      </gc-button>
    }
  </div>
</div>

@if (isMultiSpanHelpModalOpen()) {
  <app-help-modal />
}
